import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import usePerfil from '../../../hooks/usePerfil';
import Swal from "sweetalert2";

export default function ModalDir({
    ModalPassword, togglePassword,
    Password,
    token, user_id, user_rol,
    setPassword, PerfilProveGetService, PerfilCliGetService }) {

    const [showPassword, setShowPassword] = useState(false);
    const { error, message, success, PasswordUpdateService } = usePerfil();

    useEffect(() => {
        if (success === true && user_rol === 'cliente') {
            PerfilCliGetService(user_id, token)
        }
    }, [PerfilCliGetService, success])

    useEffect(() => {
        if (success === true && user_rol === 'proveedor') {
            PerfilProveGetService(user_id, token)
        }
    }, [PerfilProveGetService, success])


    const createUser = () => {
        const data = new FormData();
        data.append("user_id", user_id);
        data.append("password", Password);
        PasswordUpdateService(data, token);
    }

    useEffect(() => {
        if (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                confirmButtonColor: "#3b82f6",
                text: message,
            });
        }
    }, [message, error])

    useEffect(() => {
        if (success) {
            Swal.fire({
                icon: "success",
                title: "Exito",
                confirmButtonColor: "#3b82f6",
                text: message,
            });
            togglePassword();
        }
    }, [message, success])

    return <>
        <Modal isOpen={ModalPassword} toggle={togglePassword} size='lg'>
            <ModalHeader className="backend_titulo" toggle={togglePassword}>Actualizar Contraseña</ModalHeader>
            <ModalBody>
                <div className="crud-modal-field">
                    <label className="crud-modal-label">Nueva contraseña</label>
                    <div className="crud-password-wrap">
                        <Input
                            type={showPassword ? "text" : "password"}
                            placeholder="Nueva contraseña"
                            value={Password}
                            onChange={e => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="crud-password-toggle"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                        >
                            <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                        </button>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className="backend_boton" onClick={(() => createUser())}>Actualizar</Button>
            </ModalFooter>
        </Modal>
    </>
}
